const _ = {
  actions: {
    GetFAQList({ commit, state }, params) {
      return mm
        .http({
          url: '/api/faq/page/list',
          method: 'get',
          params: {
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
  }
}

export default _
